import { createContext } from "@pharaday/utils";

export type CommandContext = {
  isLoading: boolean;
};

const [useCommandContext, CommandContextProvider] = createContext<CommandContext>();

export { CommandContextProvider, useCommandContext };
